module.exports = __webpack_public_path__ + "static/img/member.1c03092c.png";